import { AnalysisFileType } from "../../../types/analysisFileTypes";
import { SidebarLinkPathTypes, SidebarLinkTypes } from "../../../scaffold/ui/LinkTypes";
import GenericAnalysisFilesAdminPage from "./GenericAnalysisFileAdminPage";


export default function NewEmployeesAnalysisFilesAdminPage() {
    return <GenericAnalysisFilesAdminPage
        fileType={AnalysisFileType.NewEmployeesAnalysisFile}
        title={SidebarLinkTypes.superAdminAnalysisFilesNewEmployees}
        link={SidebarLinkPathTypes.superAdminAnalysisFilesNewEmployees}
    />
}